<template>
<section class="w1312 main-content-wrap">
  <homeBanner></homeBanner>
  <recommend></recommend>
</section>
</template>

<script>
import { mapState } from 'vuex'
import homeBanner from '@/components/homeBanner.vue'
import recommend from './recommend.vue'
export default {
  name: '',
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['sessionTarget'])
  },
  methods: {
  },
  components: {
    homeBanner,
    recommend
  }
}
</script>

<style lang="scss" scoped>

.main-content-wrap {
  padding-bottom: 40px;
}
</style>
